import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "@asosteam/asos-web-react-i18n";
import InfoMessage from "src/app/components/InfoMessage";
import { OUT_OF_HOURS_MARKETS } from "src/shared/constants";

function GetInTouchInfoMessage({
  outOfHours = false,
  liveChatAvailable = false,
  storeCode = "COM",
  formatTranslation,
}) {
  const isOutOfHoursMarket = OUT_OF_HOURS_MARKETS.includes(storeCode);
  const infoMessage =
    outOfHours && isOutOfHoursMarket
      ? "cchp_live_chat_out_of_hours_message"
      : "cchp_live_chat_unavailable_message";

  if (!liveChatAvailable || (outOfHours && isOutOfHoursMarket)) {
    return (
      <InfoMessage>
        <p>{formatTranslation(infoMessage)}</p>
      </InfoMessage>
    );
  }

  return null;
}

GetInTouchInfoMessage.propTypes = {
  outOfHours: PropTypes.bool,
  liveChatAvailable: PropTypes.bool,
  chatBotEnabled: PropTypes.bool,
  language: PropTypes.string,
  storeCode: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(GetInTouchInfoMessage);
